/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

export const typography = {
  'font-family': {
    primary: 'var(--font-family-primary)',
    code: 'var(--font-family-code)',
  },
  'line-height': {
    l: 'var(--line-height-l)',
    m: 'var(--line-height-m)',
    xl: 'var(--line-height-xl)',
  },
  'font-weight': {
    'semi-bold': 'var(--font-weight-semi-bold)',
    bold: 'var(--font-weight-bold)',
    medium: 'var(--font-weight-medium)',
    regular: 'var(--font-weight-regular)',
  },
  'font-size': {
    xs: 'var(--font-size-xs)',
    s: 'var(--font-size-s)',
    m: 'var(--font-size-m)',
    l: 'var(--font-size-l)',
    xl: 'var(--font-size-xl)',
    '2xl': 'var(--font-size-2xl)',
    '3xl': 'var(--font-size-3xl)',
  },
  'letter-spacing': {
    m: 'var(--letter-spacing-m)',
    l: 'var(--letter-spacing-l)',
  },
  'paragraph-spacing': {
    '0': 'var(--paragraph-spacing-0)',
    '1': 'var(--paragraph-spacing-1)',
  },
  Base: {
    'heading-2xl': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-l)',
      fontSize: 'var(--font-size-3xl)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-xl': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-l)',
      fontSize: 'var(--font-size-2xl)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-l': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-xl)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-m': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-l)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-xs': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-s)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-s': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'heading-2xs': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-xs)',
      letterSpacing: 'var(--letter-spacing-l)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-uppercase)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'body-monoline': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'body-multiline': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-xl)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-1)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'body-multiline-tight': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-l)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'detail-m': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-xl)',
      fontSize: 'var(--font-size-s)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'detail-s': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-xs)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'code-multiline': {
      fontFamily: 'var(--font-family-code)',
      fontWeight: 'var(--font-weight-regular)',
      lineHeight: 'var(--line-height-xl)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'code-monoline': {
      fontFamily: 'var(--font-family-code)',
      fontWeight: 'var(--font-weight-regular)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
  },
  Component: {
    'multiline-button': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-xl)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    button: {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'node-heading': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-uppercase)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'calendar-item-declined': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-l)',
      fontSize: 'var(--font-size-s)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-line-through)',
    },
    'form-label': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'form-label-inline': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-s)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'form-value': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'form-value-multiline': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-xl)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-1)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'form-value-emphasis': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    item: {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'item-selected': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'item-unselected': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-medium)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
    'page-section-heading': {
      fontFamily: 'var(--font-family-primary)',
      fontWeight: 'var(--font-weight-semi-bold)',
      lineHeight: 'var(--line-height-m)',
      fontSize: 'var(--font-size-m)',
      letterSpacing: 'var(--letter-spacing-m)',
      paragraphSpacing: 'var(--paragraph-spacing-0)',
      paragraphIndent: 'var(--paragraph-indent-0)',
      textTransform: 'var(--text-transform-none)',
      textDecoration: 'var(--text-decoration-none)',
    },
  },
  'text-transform': {
    none: 'var(--text-transform-none)',
    uppercase: 'var(--text-transform-uppercase)',
  },
  'text-decoration': {
    none: 'var(--text-decoration-none)',
    'line-through': 'var(--text-decoration-line-through)',
  },
  'paragraph-indent': {
    '0': 'var(--paragraph-indent-0)',
  },
}
export const dimensions = {
  BorderRadius: {
    none: 'var(--border-radius-none)',
    '2xs': 'var(--border-radius-2xs)',
    s: 'var(--border-radius-s)',
    m: 'var(--border-radius-m)',
    l: 'var(--border-radius-l)',
    full: 'var(--border-radius-full)',
    xs: 'var(--border-radius-xs)',
    xl: 'var(--border-radius-xl)',
    'button-2xs': 'var(--border-radius-button-2xs)',
    'button-xs': 'var(--border-radius-button-xs)',
    'button-s': 'var(--border-radius-button-s)',
    'button-m': 'var(--border-radius-button-m)',
    'formItem-m': 'var(--border-radius-form-item-m)',
    'button-l': 'var(--border-radius-button-l)',
    'formItem-s': 'var(--border-radius-form-item-s)',
    popover: 'var(--border-radius-popover)',
    section: 'var(--border-radius-section)',
  },
  Space: {
    'padding-form-item-m': 'var(--space-padding-form-item-m)',
    'padding-button-m': 'var(--space-padding-button-m)',
    'padding-button-s': 'var(--space-padding-button-s)',
    'padding-button-nested': 'var(--space-padding-button-nested)',
    'padding-form-item-nested': 'var(--space-padding-form-item-nested)',
    'padding-form-item-s': 'var(--space-padding-form-item-s)',
    'margin-form-item-content': 'var(--space-margin-form-item-content)',
    'padding-form-item-xs': 'var(--space-padding-form-item-xs)',
    page: 'var(--space-page)',
    modal: 'var(--space-modal)',
    'wide-panel': 'var(--space-wide-panel)',
    'narrow-panel': 'var(--space-narrow-panel)',
    section: 'var(--space-section)',
    'page-content-m': 'var(--space-page-content-m)',
    'narrow-panel-content-m': 'var(--space-narrow-panel-content-m)',
    'wide-panel-content-m': 'var(--space-wide-panel-content-m)',
    'section-content-m': 'var(--space-section-content-m)',
    'narrow-panel-content-s': 'var(--space-narrow-panel-content-s)',
    'wide-panel-content-s': 'var(--space-wide-panel-content-s)',
    'section-content-s': 'var(--space-section-content-s)',
    'page-content-s': 'var(--space-page-content-s)',
    'narrow-panel-content-l': 'var(--space-narrow-panel-content-l)',
    xs: 'var(--space-xs)',
    '2xs': 'var(--space-2xs)',
    l: 'var(--space-l)',
    s: 'var(--space-s)',
    m: 'var(--space-m)',
    '3xs': 'var(--space-3xs)',
    xl: 'var(--space-xl)',
    '2xl': 'var(--space-2xl)',
    '3xl': 'var(--space-3xl)',
    '4xl': 'var(--space-4xl)',
    '5xl': 'var(--space-5xl)',
  },
  Height: {
    'control-height-m': 'var(--height-control-height-m)',
    'control-height-s': 'var(--height-control-height-s)',
    'control-height-l': 'var(--height-control-height-l)',
    'control-height-xl': 'var(--height-control-height-xl)',
    'control-height-2xl': 'var(--height-control-height-2xl)',
    'control-height-xs': 'var(--height-control-height-xs)',
    'control-height-2xs': 'var(--height-control-height-2xs)',
    'control-height-3xs': 'var(--height-control-height-3xs)',
    'form-item-m': 'var(--height-form-item-m)',
    'form-item-s': 'var(--height-form-item-s)',
    'form-item-nested': 'var(--height-form-item-nested)',
    'button-m': 'var(--height-button-m)',
    'button-s': 'var(--height-button-s)',
  },
}
export const colors = {
  bg: {
    'node-item-delay': 'var(--bg-node-item-delay)',
    'node-item-delay-hovered': 'var(--bg-node-item-delay-hovered)',
    'node-item-evaluation': 'var(--bg-node-item-evaluation)',
    'node-item-evaluation-hovered': 'var(--bg-node-item-evaluation-hovered)',
    'node-item-action': 'var(--bg-node-item-action)',
    'node-item-action-hovered': 'var(--bg-node-item-action-hovered)',
    'node-item-interaction': 'var(--bg-node-item-interaction)',
    'node-item-interaction-hovered': 'var(--bg-node-item-interaction-hovered)',
    'node-item-trigger': 'var(--bg-node-item-trigger)',
    'node-item-trigger-hovered': 'var(--bg-node-item-trigger-hovered)',
    'node-item-enrich': 'var(--bg-node-item-enrich)',
    'node-item-enrich-hovered': 'var(--bg-node-item-enrich-hovered)',
    'node-item-chat-ai': 'var(--bg-node-item-chat-ai)',
    accent: 'var(--bg-accent)',
    'action-bar-button-caution-hovered': 'var(--bg-action-bar-button-caution-hovered)',
    'action-bar-button-major-hovered': 'var(--bg-action-bar-button-major-hovered)',
    'action-bar-button-minor-hovered': 'var(--bg-action-bar-button-minor-hovered)',
    'action-bar-button-major-default': 'var(--bg-action-bar-button-major-default)',
    'action-bar-button-minor-default': 'var(--bg-action-bar-button-minor-default)',
    'action-bar-button-caution-default': 'var(--bg-action-bar-button-caution-default)',
    'action-bar-button-major-active': 'var(--bg-action-bar-button-major-active)',
    'action-bar-button-minor-active': 'var(--bg-action-bar-button-minor-active)',
    'action-bar-button-caution-active': 'var(--bg-action-bar-button-caution-active)',
    'button-caution-default': 'var(--bg-button-caution-default)',
    'button-caution-active': 'var(--bg-button-caution-active)',
    'button-major-active': 'var(--bg-button-major-active)',
    'button-minor-active': 'var(--bg-button-minor-active)',
    'button-moderate-active': 'var(--bg-button-moderate-active)',
    'button-caution-hovered': 'var(--bg-button-caution-hovered)',
    'button-major-hovered': 'var(--bg-button-major-hovered)',
    'button-minor-hovered': 'var(--bg-button-minor-hovered)',
    'button-moderate-hovered': 'var(--bg-button-moderate-hovered)',
    'button-major-default': 'var(--bg-button-major-default)',
    'button-minor-default': 'var(--bg-button-minor-default)',
    'button-moderate-default': 'var(--bg-button-moderate-default)',
    section: 'var(--bg-section)',
    'section-emphasis': 'var(--bg-section-emphasis)',
    'dim-overlay': 'var(--bg-dim-overlay)',
    dropdown: 'var(--bg-dropdown)',
    caution: 'var(--bg-caution)',
    inform: 'var(--bg-inform)',
    success: 'var(--bg-success)',
    warning: 'var(--bg-warning)',
    'form-item-error': 'var(--bg-form-item-error)',
    'form-item-focused': 'var(--bg-form-item-focused)',
    'form-item-hovered': 'var(--bg-form-item-hovered)',
    'form-item-default': 'var(--bg-form-item-default)',
    'form-item-selection': 'var(--bg-form-item-selection)',
    'list-item-hovered': 'var(--bg-list-item-hovered)',
    'list-item-default': 'var(--bg-list-item-default)',
    'list-item-selected': 'var(--bg-list-item-selected)',
    modal: 'var(--bg-modal)',
    moderate: 'var(--bg-moderate)',
    page: 'var(--bg-page)',
    'row-default': 'var(--bg-row-default)',
    'row-selected': 'var(--bg-row-selected)',
    'scrollbar-scrollbar-background': 'var(--bg-scrollbar-scrollbar-background)',
    'scrollbar-scrollbar-control': 'var(--bg-scrollbar-scrollbar-control)',
    'select-item-major-checked-disabled': 'var(--bg-select-item-major-checked-disabled)',
    'select-item-major-checked': 'var(--bg-select-item-major-checked)',
    'select-item-status-checked': 'var(--bg-select-item-status-checked)',
    'select-item-status-checked-disabled': 'var(--bg-select-item-status-checked-disabled)',
    'select-item-unchecked': 'var(--bg-select-item-unchecked)',
    'select-item-unchecked-disabled': 'var(--bg-select-item-unchecked-disabled)',
    'skeleton-default': 'var(--bg-skeleton-default)',
    'skeleton-flicker': 'var(--bg-skeleton-flicker)',
    disabled: 'var(--bg-disabled)',
    'main-nav-hovered': 'var(--bg-main-nav-hovered)',
    'main-nav-selected': 'var(--bg-main-nav-selected)',
    'main-nav-default': 'var(--bg-main-nav-default)',
    'main-nav-disabled': 'var(--bg-main-nav-disabled)',
    minor: 'var(--bg-minor)',
    'action-emphasis': 'var(--bg-action-emphasis)',
    action: 'var(--bg-action)',
    'success-emphasis': 'var(--bg-success-emphasis)',
    major: 'var(--bg-major)',
    invisible: 'var(--bg-invisible)',
    'caution-emphasis': 'var(--bg-caution-emphasis)',
    'action-bar': 'var(--bg-action-bar)',
    navigation: 'var(--bg-navigation)',
    'warning-emphasis': 'var(--bg-warning-emphasis)',
    'inform-emphasis': 'var(--bg-inform-emphasis)',
    'brand-emphasis': 'var(--bg-brand-emphasis)',
    'calendar-item-grey': 'var(--bg-calendar-item-grey)',
    'calendar-item-grey-hovered': 'var(--bg-calendar-item-grey-hovered)',
    'calendar-item-red': 'var(--bg-calendar-item-red)',
    'calendar-item-red-hovered': 'var(--bg-calendar-item-red-hovered)',
    'calendar-item-orange': 'var(--bg-calendar-item-orange)',
    'calendar-item-orange-hovered': 'var(--bg-calendar-item-orange-hovered)',
    'calendar-item-yellow': 'var(--bg-calendar-item-yellow)',
    'calendar-item-yellow-hovered': 'var(--bg-calendar-item-yellow-hovered)',
    'calendar-item-green': 'var(--bg-calendar-item-green)',
    'calendar-item-green-hovered': 'var(--bg-calendar-item-green-hovered)',
    'calendar-item-blue': 'var(--bg-calendar-item-blue)',
    'calendar-item-blue-hovered': 'var(--bg-calendar-item-blue-hovered)',
    'calendar-item-purple': 'var(--bg-calendar-item-purple)',
    'calendar-item-purple-hovered': 'var(--bg-calendar-item-purple-hovered)',
    'calendar-item-pink': 'var(--bg-calendar-item-pink)',
    'calendar-item-pink-hovered': 'var(--bg-calendar-item-pink-hovered)',
    'calendar-item-grey-focused': 'var(--bg-calendar-item-grey-focused)',
    'calendar-item-blue-focused': 'var(--bg-calendar-item-blue-focused)',
    'calendar-item-purple-focused': 'var(--bg-calendar-item-purple-focused)',
    'calendar-item-pink-focused': 'var(--bg-calendar-item-pink-focused)',
    'calendar-item-red-focused': 'var(--bg-calendar-item-red-focused)',
    'calendar-item-orange-focused': 'var(--bg-calendar-item-orange-focused)',
    'calendar-item-yellow-focused': 'var(--bg-calendar-item-yellow-focused)',
    'calendar-item-green-focused': 'var(--bg-calendar-item-green-focused)',
    'flow-builder-selection-area': 'var(--bg-flow-builder-selection-area)',
    'chart-purple': 'var(--bg-chart-purple)',
    'chart-yellow': 'var(--bg-chart-yellow)',
    'chart-red': 'var(--bg-chart-red)',
    'chart-blue': 'var(--bg-chart-blue)',
    'chart-green': 'var(--bg-chart-green)',
    'chart-grey': 'var(--bg-chart-grey)',
    'chart-orange': 'var(--bg-chart-orange)',
  },
  fg: {
    hubspot: 'var(--fg-hubspot)',
    salesforce: 'var(--fg-salesforce)',
    caution: 'var(--fg-caution)',
    success: 'var(--fg-success)',
    'major-on-color': 'var(--fg-major-on-color)',
    brand: 'var(--fg-brand)',
    inform: 'var(--fg-inform)',
    action: 'var(--fg-action)',
    moderate: 'var(--fg-moderate)',
    'moderate-on-color': 'var(--fg-moderate-on-color)',
    warning: 'var(--fg-warning)',
    'calendar-item-green': 'var(--fg-calendar-item-green)',
    'calendar-item-blue': 'var(--fg-calendar-item-blue)',
    'calendar-item-yellow': 'var(--fg-calendar-item-yellow)',
    'calendar-item-pink': 'var(--fg-calendar-item-pink)',
    'calendar-item-grey': 'var(--fg-calendar-item-grey)',
    'calendar-item-red': 'var(--fg-calendar-item-red)',
    'calendar-item-purple': 'var(--fg-calendar-item-purple)',
    'calendar-item-orange': 'var(--fg-calendar-item-orange)',
    'calendar-item-arrow': 'var(--fg-calendar-item-arrow)',
    disabled: 'var(--fg-disabled)',
    major: 'var(--fg-major)',
    minor: 'var(--fg-minor)',
    'action-on-color': 'var(--fg-action-on-color)',
    'caution-on-color': 'var(--fg-caution-on-color)',
    'warning-on-color': 'var(--fg-warning-on-color)',
    'success-on-color': 'var(--fg-success-on-color)',
    'inform-on-color': 'var(--fg-inform-on-color)',
    'node-item-action': 'var(--fg-node-item-action)',
    'node-item-interaction': 'var(--fg-node-item-interaction)',
    'node-item-evaluation': 'var(--fg-node-item-evaluation)',
    'node-item-delay': 'var(--fg-node-item-delay)',
    'node-item-trigger': 'var(--fg-node-item-trigger)',
    'node-item-arrow': 'var(--fg-node-item-arrow)',
    'node-item-enrich': 'var(--fg-node-item-enrich)',
    'node-item-chat-ai': 'var(--fg-node-item-chat-ai)',
  },
  base: {
    'orange-8': 'var(--base-orange-8)',
    'orange-16': 'var(--base-orange-16)',
    'orange-24': 'var(--base-orange-24)',
    'orange-32': 'var(--base-orange-32)',
    'orange-40': 'var(--base-orange-40)',
    'orange-48': 'var(--base-orange-48)',
    'orange-56': 'var(--base-orange-56)',
    'orange-64': 'var(--base-orange-64)',
    'orange-80': 'var(--base-orange-80)',
    'orange-100': 'var(--base-orange-100)',
    'blue-8': 'var(--base-blue-8)',
    'blue-16': 'var(--base-blue-16)',
    'blue-24': 'var(--base-blue-24)',
    'blue-32': 'var(--base-blue-32)',
    'blue-40': 'var(--base-blue-40)',
    'blue-48': 'var(--base-blue-48)',
    'blue-56': 'var(--base-blue-56)',
    'blue-64': 'var(--base-blue-64)',
    'blue-80': 'var(--base-blue-80)',
    'blue-100': 'var(--base-blue-100)',
    'red-8': 'var(--base-red-8)',
    'red-16': 'var(--base-red-16)',
    'red-24': 'var(--base-red-24)',
    'red-32': 'var(--base-red-32)',
    'red-40': 'var(--base-red-40)',
    'red-48': 'var(--base-red-48)',
    'red-56': 'var(--base-red-56)',
    'red-64': 'var(--base-red-64)',
    'red-80': 'var(--base-red-80)',
    'red-100': 'var(--base-red-100)',
    'green-8': 'var(--base-green-8)',
    'green-16': 'var(--base-green-16)',
    'green-24': 'var(--base-green-24)',
    'green-32': 'var(--base-green-32)',
    'green-40': 'var(--base-green-40)',
    'green-48': 'var(--base-green-48)',
    'green-56': 'var(--base-green-56)',
    'green-64': 'var(--base-green-64)',
    'green-80': 'var(--base-green-80)',
    'green-100': 'var(--base-green-100)',
    'yellow-8': 'var(--base-yellow-8)',
    'yellow-16': 'var(--base-yellow-16)',
    'yellow-24': 'var(--base-yellow-24)',
    'yellow-32': 'var(--base-yellow-32)',
    'yellow-40': 'var(--base-yellow-40)',
    'yellow-48': 'var(--base-yellow-48)',
    'yellow-56': 'var(--base-yellow-56)',
    'yellow-64': 'var(--base-yellow-64)',
    'yellow-80': 'var(--base-yellow-80)',
    'yellow-100': 'var(--base-yellow-100)',
    'purple-8': 'var(--base-purple-8)',
    'purple-16': 'var(--base-purple-16)',
    'purple-24': 'var(--base-purple-24)',
    'purple-32': 'var(--base-purple-32)',
    'purple-40': 'var(--base-purple-40)',
    'purple-48': 'var(--base-purple-48)',
    'purple-56': 'var(--base-purple-56)',
    'purple-64': 'var(--base-purple-64)',
    'purple-80': 'var(--base-purple-80)',
    'purple-100': 'var(--base-purple-100)',
    'neutral-0': 'var(--base-neutral-0)',
    'neutral-2': 'var(--base-neutral-2)',
    'neutral-3': 'var(--base-neutral-3)',
    'neutral-4': 'var(--base-neutral-4)',
    'neutral-8': 'var(--base-neutral-8)',
    'neutral-12': 'var(--base-neutral-12)',
    'neutral-16': 'var(--base-neutral-16)',
    'neutral-20': 'var(--base-neutral-20)',
    'neutral-24': 'var(--base-neutral-24)',
    'neutral-32': 'var(--base-neutral-32)',
    'neutral-40': 'var(--base-neutral-40)',
    'neutral-48': 'var(--base-neutral-48)',
    'neutral-56': 'var(--base-neutral-56)',
    'neutral-64': 'var(--base-neutral-64)',
    'neutral-80': 'var(--base-neutral-80)',
    'neutral-100': 'var(--base-neutral-100)',
    'transparency-neutral-at-80': 'var(--base-transparency-neutral-at-80)',
    'transparency-neutral-at-32': 'var(--base-transparency-neutral-at-32)',
    'transparency-purple-at-20': 'var(--base-transparency-purple-at-20)',
    'transparency-purple-at-10': 'var(--base-transparency-purple-at-10)',
    'transparency-neutral-at-16': 'var(--base-transparency-neutral-at-16)',
    'transparency-orange-at-64': 'var(--base-transparency-orange-at-64)',
    'pink-8': 'var(--base-pink-8)',
    'pink-16': 'var(--base-pink-16)',
    'pink-24': 'var(--base-pink-24)',
    'pink-32': 'var(--base-pink-32)',
    'pink-40': 'var(--base-pink-40)',
    'pink-48': 'var(--base-pink-48)',
    'pink-56': 'var(--base-pink-56)',
    'pink-64': 'var(--base-pink-64)',
    'pink-80': 'var(--base-pink-80)',
    'pink-100': 'var(--base-pink-100)',
  },
  effect: {
    minor: 'var(--effect-minor)',
    'drop-shadow': 'var(--effect-drop-shadow)',
    moderate: 'var(--effect-moderate)',
    'action-emphasis': 'var(--effect-action-emphasis)',
    action: 'var(--effect-action)',
    'default-on-color': 'var(--effect-default-on-color)',
    'moderate-on-color': 'var(--effect-moderate-on-color)',
    inform: 'var(--effect-inform)',
    warning: 'var(--effect-warning)',
    caution: 'var(--effect-caution)',
    'caution-emphasis': 'var(--effect-caution-emphasis)',
    'inform-emphasis': 'var(--effect-inform-emphasis)',
    'warning-emphasis': 'var(--effect-warning-emphasis)',
    success: 'var(--effect-success)',
    'success-emphasis': 'var(--effect-success-emphasis)',
    major: 'var(--effect-major)',
    'brand-emphasis': 'var(--effect-brand-emphasis)',
    'focus-indicator': 'var(--effect-focus-indicator)',
  },
  border: {
    'action-focused-caution': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-caution-emphasis)',
    },
    'action-focused-major': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-action-emphasis)',
    },
    'action-focused-minor': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-major)',
    },
    'action-focused-moderate': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-major)',
    },
    'calendar-cell': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'card-item-hovered': {
      x: '0px',
      y: '0px',
      blur: '0px',
      spread: '1px',
      color: 'var(--effect-action)',
    },
    'card-item-selected': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    cell: {
      x: '-1px',
      y: '0px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-minor)',
    },
    'cell-left': {
      x: '1px',
      y: '0px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-minor)',
    },
    'cell-left-on-color': {
      x: '1px',
      y: '0px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate-on-color)',
    },
    'cell-on-color': {
      x: '-1px',
      y: '0px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate-on-color)',
    },
    'cell-sticky-left': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'focus-indicator': {
      x: '0px',
      y: '0px',
      blur: '0px',
      spread: '2px',
      color: 'var(--effect-focus-indicator)',
    },
    'focus-indicator-item-selected': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'form-item-focused': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'form-item-nested-focused': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-action-emphasis)',
    },
    'horizontal-nav-item-hovered': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate)',
    },
    'horizontal-nav-item-major-selected': {
      x: '0px',
      y: '-3px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-brand-emphasis)',
    },
    'horizontal-nav-item-minor-selected': {
      x: '0px',
      y: '-3px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-major)',
    },
    'link-underline-caution': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-caution)',
    },
    'link-underline-caution-hover': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-caution-emphasis)',
    },
    'link-underline-major': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-action)',
    },
    'link-underline-major-hover': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-action-emphasis)',
    },
    'link-underline-minor': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate)',
    },
    'link-underline-minor-hover': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-major)',
    },
    'link-underline-moderate-on-color': {
      x: '0px',
      y: '-2px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate-on-color)',
    },
    'list-item-selected': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    node: {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'node-selected': {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    'page-divider-section': {
      x: '0px',
      y: '-4px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-minor)',
    },
    popover: {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    row: {
      x: '0px',
      y: '-1px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-minor)',
    },
    'row-oncolor': {
      x: '0px',
      y: '-1px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate-on-color)',
    },
    'row-selected': {
      x: '0px',
      y: '-1px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-moderate)',
    },
    'row-top': {
      x: '0px',
      y: '1px',
      blur: '0px',
      spread: '0px',
      color: 'var(--effect-minor)',
    },
    section: {
      x: '0px',
      y: '0px',
      blur: '0px',
      spread: '1px',
      color: 'var(--effect-minor)',
    },
    'section-on-color': {
      x: '0px',
      y: '0px',
      blur: '0px',
      spread: '1px',
      color: 'var(--effect-moderate-on-color)',
    },
    inform: {
      '0': '[object Object]',
      '1': '[object Object]',
    },
    success: {
      '0': '[object Object]',
      '1': '[object Object]',
    },
  },
}
